const RNA_OLIGOS_PAGE = '/';

export default {
  RNA_OLIGOS_PAGE,
  PATHS: [RNA_OLIGOS_PAGE]
};
